import axios from 'axios'

// state
const state = { }

// getters
const getters = { }

// actions
const actions = {
  /* action: call
  ** params: data
  **  - method: POST or GET - default: GET
  **  - endPoint: service endPoint
  **  - data: Only Post Services - Input Object
  **  - params: Only Get Services - Input Parameters
  **  - mutation: Mutation to update the referred state
   */
  callService ({ commit, state }, data) {
    return axios({
      method: data.method === undefined ? 'GET' : data.method,
      url: data.endpoint,
      headers: {
        Accept: 'application/json',
        Authorization: `${sessionStorage.getItem('sessionToken')}`
      },
      data: data.data,
      params: data.params
    })
      .then((response) => {
        if (data.tipo) {
          response.data.tipo = data.tipo
        }
        commit(data.mutation, response.data)
      })
      .catch((error) => {
        console.log(error)
        // Provisional mientras que los servicios devuelvan error 404
        commit(data.mutation, [])
      })
  },
  callServiceMsg ({ commit, state }, data) {
    return axios({
      method: data.method === undefined ? 'GET' : data.method,
      url: data.endpoint,
      headers: {
        Accept: 'application/json',
        Authorization: 'a' // + store.token
      },
      data: data.data,
      params: data.params
    })
      .then((response) => {
        commit(data.mutation, response.data)
        // console.log(response)
      })
      .catch((error) => {
        console.log(error)
        // console.log(data.msg.ok)
        // Provisional mientras que los servicios devuelvan error 404
        commit(data.mutation, [])
      })
  }
}

// mutations
const mutations = { }

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/callServices.js